// extracted by mini-css-extract-plugin
module.exports = {"service-agreement-wrapper":"service-agreement-wrapper__1J1yl","check-confirm":"check-confirm__2FBIk"};